export default __webpack_public_path__ + "static/media/give2_kids_logo.27f1a164.jpg";